// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1M0G1","col":"styles_col__3HeDD"};